import React from 'react'
import type { Coach } from '../../Api'
import { CardCon } from './styles'
import { Img } from '../Image/Img'

type PersonStatsCardProps = {
  coach: Coach
}

export const CoachCard: React.FC<React.PropsWithChildren<PersonStatsCardProps>> = ({
  coach,
}) => {
  return (
    <CardCon cardType="coach" height={205}>
      <div className="innerPad">
        {coach?.profileUrl && <Img src={coach.profileUrl} alt={`${coach.firstName} ${coach.lastName}`} />}
        <div className="coachNameRow">
          <div className="firstName">{coach.firstName}</div>
          <div className="lastName">{coach.lastName}</div>
        </div>
        <div className="coachSummary">{coach.summary}</div>
      </div>
    </CardCon>
  )
}
